<template>
  <div class="products">
    <Header />
    
    <!-- 背景装饰 -->
    <div class="tech-background"></div>
    <div class="grid-overlay"></div>
    
    <div class="container mx-auto px-4 pt-40 pb-20">
      <h1 class="page-title text-4xl md:text-5xl font-bold mb-12 text-center">
        <span class="title-text">产品查询</span>
        <div class="title-line"></div>
      </h1>

      <!-- 查询表单 -->
      <div class="glass-card query-form-card mb-8 max-w-4xl mx-auto">
        <div class="query-form p-8">
          <h2 class="section-title text-2xl font-semibold mb-8">
            <i class="fas fa-search mr-3"></i>设备信息查询
          </h2>
          <el-form :model="queryForm" :rules="queryRules" ref="queryForm" label-width="100px">
            <el-form-item label="设备号" prop="deviceNumber">
              <el-input v-model="queryForm.deviceNumber" placeholder="请输入设备号" clearable class="tech-input">
                <i slot="prefix" class="el-input__icon fas fa-barcode"></i>
              </el-input>
            </el-form-item>
            <el-form-item label="缴费账号" prop="paymentAccount">
              <el-input v-model="queryForm.paymentAccount" placeholder="请输入缴费账号" clearable class="tech-input">
                <i slot="prefix" class="el-input__icon fas fa-credit-card"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <div class="button-group">
                <el-button type="primary" size="large" :loading="loading" @click="handleQuery" class="query-btn">
                  <i class="fas fa-search mr-2"></i>
                  {{ loading ? '查询中...' : '查询设备信息' }}
                </el-button>
                <el-button size="large" @click="handleReset" class="reset-btn">
                  <i class="fas fa-redo mr-2"></i>重置
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <!-- 查询结果 -->
      <div v-if="queryResult" class="glass-card result-card max-w-6xl mx-auto">
        <div class="card-header">
          <h3 class="section-title text-xl">
            <i class="fas fa-clipboard-list mr-3"></i>查询结果
          </h3>
        </div>
        <div class="result-content p-8">
          <div class="info-grid">
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-barcode"></i>
              </div>
              <div class="info-text">
                <span class="info-label">设备号</span>
                <span class="info-value">{{ queryResult.device.device_no }}</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-credit-card"></i>
              </div>
              <div class="info-text">
                <span class="info-label">缴费账号</span>
                <span class="info-value">{{ queryResult.binding_info.customer_account }}</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-box"></i>
              </div>
              <div class="info-text">
                <span class="info-label">套餐类型</span>
                <span class="info-value">{{ queryResult.package.package_name }}</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-signal"></i>
              </div>
              <div class="info-text">
                <span class="info-label">设备状态</span>
                <span class="info-value">
                  <el-tag :type="queryResult.device.status === '2' ? 'success' : 'danger'" class="status-tag">
                    {{ queryResult.device.status === '2' ? '正常' : '异常' }}
                  </el-tag>
                </span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-building"></i>
              </div>
              <div class="info-text">
                <span class="info-label">名称</span>
                <span class="info-value ellipsis" :title="queryResult.customer.customer_name">{{ queryResult.customer.customer_name }}</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-user"></i>
              </div>
              <div class="info-text">
                <span class="info-label">联系人</span>
                <span class="info-value">{{ queryResult.customer.contact_person }}</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-phone"></i>
              </div>
              <div class="info-text">
                <span class="info-label">联系电话</span>
                <span class="info-value">{{ queryResult.customer.contact_phone }}</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-calendar-check"></i>
              </div>
              <div class="info-text">
                <span class="info-label">开通时间</span>
                <span class="info-value">{{ queryResult.binding_info.completion_time }}</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-map-marker-alt"></i>
              </div>
              <div class="info-text">
                <span class="info-label">安装地址</span>
                <span class="info-value ellipsis" :title="queryResult.customer.install_address">{{ queryResult.customer.install_address }}</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-check-circle"></i>
              </div>
              <div class="info-text">
                <span class="info-label">缴费状态</span>
                <span class="info-value">
                  <el-tag :type="queryResult.binding_info.status === '1' ? 'success' : 'danger'" class="status-tag">
                    {{ queryResult.binding_info.status === '1' ? '正常' : '异常' }}
                  </el-tag>
                </span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-wallet"></i>
              </div>
              <div class="info-text">
                <span class="info-label">当前余额</span>
                <span class="info-value balance-highlight">{{ queryResult.account.balance }} 元</span>
              </div>
            </div>
            <div class="info-item">
              <div class="info-icon">
                <i class="fas fa-calendar-times"></i>
              </div>
              <div class="info-text">
                <span class="info-label">到期时间</span>
                <span class="info-value">{{ queryResult.binding_info.expire_time }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 未查询状态 -->
      <div v-if="!queryResult && hasSearched" class="no-result glass-card max-w-4xl mx-auto">
        <el-empty description="暂无查询结果，请检查输入的设备号和缴费账号是否正确">
          <i slot="image" class="fas fa-search empty-icon"></i>
        </el-empty>
      </div>
    </div>
    <Footer />
    <BackToTop />
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';
import BackToTop from '../components/BackToTop.vue';
import axios from 'axios';

export default {
  name: 'Products',
  components: {
    Header,
    Footer,
    BackToTop
  },
  data() {
    return {
      queryForm: {
        deviceNumber: '',
        paymentAccount: ''
      },
      queryRules: {
        deviceNumber: [
          { required: true, message: '请输入设备号', trigger: ['blur', 'change'] },
          { min: 5, max: 20, message: '设备号长度在5到20个字符之间', trigger: ['blur', 'change'] },
          { pattern: /^[A-Za-z0-9]+$/, message: '设备号只能包含字母和数字', trigger: ['blur', 'change'] }
        ],
        paymentAccount: [
          { required: true, message: '请输入缴费账号', trigger: ['blur', 'change'] },
          { min: 5, max: 20, message: '缴费账号长度在5到20个字符之间', trigger: ['blur', 'change'] },
          { pattern: /^[A-Za-z0-9]+$/, message: '缴费账号只能包含字母和数字', trigger: ['blur', 'change'] }
        ]
      },
      loading: false,
      queryResult: null,
      hasSearched: false
    };
  },
  methods: {
    // 处理查询
    async handleQuery() {
      this.$refs.queryForm.validate(async valid => {
        if (valid) {
          this.loading = true;
          this.hasSearched = true;

          try {
            // 调用真实接口
            const response = await this.fetchDeviceInfo();
            if (response.data.success) {
              this.queryResult = response.data.data;
              this.$message.success(response.data.message || '查询成功');
            } else {
              this.$message.error(response.data.message || '查询失败');
              this.queryResult = null;
            }
          } catch (error) {
            console.error('查询失败:', error);
            this.$message.error('查询失败，请稍后重试');
            this.queryResult = null;
          } finally {
            this.loading = false;
          }
        } else {
          this.$message.warning('请填写完整的查询信息');
        }
      });
    },
    // 调用真实接口获取设备信息
    async fetchDeviceInfo() {
      const response = await axios.get('/node/api/v1/public/getCustomerAndPackageByDeviceNo', {
        params: {
          device_no: this.queryForm.deviceNumber,
          recharge_account: this.queryForm.paymentAccount
        }
      });
      return response;
    },
    // 处理重置
    handleReset() {
      this.$refs.queryForm.resetFields();
      this.queryResult = null;
      this.hasSearched = false;
    }
  }
};
</script>

<style scoped>
.products {
  min-height: 100vh;
  position: relative;
  background: linear-gradient(135deg, #0a0e27 0%, #1a1f3a 50%, #0f1428 100%);
  overflow: hidden;
}

/* 科技感背景 */
.tech-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(ellipse at 20% 30%, rgba(56, 189, 248, 0.15) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 70%, rgba(147, 51, 234, 0.15) 0%, transparent 50%);
  pointer-events: none;
  z-index: 1;
}

.grid-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(56, 189, 248, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(56, 189, 248, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
  z-index: 1;
}

.container {
  position: relative;
  z-index: 2;
}

/* 页面标题 */
.page-title {
  color: #fff;
  text-shadow: 0 0 20px rgba(56, 189, 248, 0.5);
  animation: titleGlow 3s ease-in-out infinite;
}

.title-text {
  display: inline-block;
  background: linear-gradient(135deg, #38bdf8 0%, #a78bfa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.title-line {
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, transparent, #38bdf8, #a78bfa, transparent);
  margin: 16px auto 0;
  border-radius: 2px;
  animation: lineGlow 2s ease-in-out infinite;
}

@keyframes titleGlow {
  0%, 100% { text-shadow: 0 0 20px rgba(56, 189, 248, 0.5); }
  50% { text-shadow: 0 0 30px rgba(56, 189, 248, 0.8), 0 0 40px rgba(147, 51, 234, 0.4); }
}

@keyframes lineGlow {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}

/* 玻璃拟态卡片 */
.glass-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.3),
    inset 0 1px 1px rgba(255, 255, 255, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: fadeInUp 0.6s ease-out;
}

.glass-card:hover {
  transform: translateY(-5px);
  border-color: rgba(56, 189, 248, 0.3);
  box-shadow: 
    0 12px 48px rgba(0, 0, 0, 0.4),
    0 0 30px rgba(56, 189, 248, 0.2),
    inset 0 1px 1px rgba(255, 255, 255, 0.15);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 区块标题 */
.section-title {
  color: #fff;
  position: relative;
  padding-bottom: 12px;
}

.section-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #38bdf8, #a78bfa);
  border-radius: 2px;
}

.section-title i {
  background: linear-gradient(135deg, #38bdf8, #a78bfa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 表单样式 */
.products :deep(.el-form-item__label) {
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

.products :deep(.tech-input .el-input__inner) {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: 15px;
  padding: 14px 18px 14px 40px;
  height: 48px;
  transition: all 0.3s ease;
}

.products :deep(.tech-input .el-input__inner::placeholder) {
  color: rgba(255, 255, 255, 0.4);
}

.products :deep(.tech-input .el-input__inner:focus) {
  background: rgba(255, 255, 255, 0.08);
  border-color: #38bdf8;
  box-shadow: 0 0 20px rgba(56, 189, 248, 0.3);
}

.products :deep(.tech-input .el-input__prefix) {
  left: 12px;
  color: rgba(56, 189, 248, 0.8);
}

.products :deep(.el-form-item) {
  margin-bottom: 24px;
}

/* 按钮组 */
.button-group {
  display: flex;
  gap: 16px;
  justify-content: center;
  width: 100%;
  margin-left: -100px;
  padding-left: 100px;
}

.query-btn,
.reset-btn {
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 1px;
  border-radius: 12px;
  min-width: 200px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.query-btn {
  background: linear-gradient(135deg, #38bdf8 0%, #a78bfa 100%);
  border: none;
  box-shadow: 0 4px 20px rgba(56, 189, 248, 0.4);
}

.query-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 30px rgba(56, 189, 248, 0.6);
}

.query-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.query-btn:hover::before {
  left: 100%;
}

.reset-btn {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
}

.reset-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(56, 189, 248, 0.4);
  transform: translateY(-2px);
}

/* 卡片头部 */
.card-header {
  padding: 24px 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* 查询结果网格 */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 16px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  padding: 20px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}

.info-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(56, 189, 248, 0.3);
  transform: translateX(5px);
}

/* 信息图标 */
.info-icon {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.2), rgba(147, 51, 234, 0.2));
  border-radius: 12px;
  border: 1px solid rgba(56, 189, 248, 0.3);
  box-shadow: 0 4px 16px rgba(56, 189, 248, 0.2);
  margin-right: 16px;
  transition: all 0.3s ease;
}

.info-item:hover .info-icon {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 6px 20px rgba(56, 189, 248, 0.4);
}

.info-icon i {
  font-size: 20px;
  background: linear-gradient(135deg, #38bdf8, #a78bfa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* 信息文本 */
.info-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #38bdf8;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

.balance-highlight {
  color: #38bdf8;
  font-size: 1.125rem;
  font-weight: 700;
}

/* 状态标签 */
.products :deep(.status-tag) {
  border-radius: 6px;
  padding: 4px 12px;
  font-weight: 500;
}

.products :deep(.el-tag--success) {
  background: rgba(34, 197, 94, 0.2);
  border-color: rgba(34, 197, 94, 0.4);
  color: #4ade80;
}

.products :deep(.el-tag--danger) {
  background: rgba(239, 68, 68, 0.2);
  border-color: rgba(239, 68, 68, 0.4);
  color: #f87171;
}

/* 超长省略样式 */
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: 250px;
  vertical-align: middle;
}

/* 空结果样式 */
.no-result {
  padding: 60px 40px;
  text-align: center;
}

.products :deep(.el-empty__description) {
  color: rgba(255, 255, 255, 0.6);
}

.empty-icon {
  font-size: 80px;
  color: rgba(56, 189, 248, 0.3);
}

/* 表单验证错误提示 */
.products :deep(.el-form-item__error) {
  color: #ff6b9d;
  font-size: 13px;
  padding-top: 4px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .products {
    padding-top: 60px;
  }

  .container {
    padding: 0 16px !important;
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }

  .page-title {
    font-size: 2rem !important;
    margin-bottom: 32px !important;
  }

  .query-form {
    padding: 24px !important;
  }

  .section-title {
    font-size: 1.25rem !important;
    margin-bottom: 24px !important;
  }

  .products :deep(.el-form-item__label) {
    display: none;
  }

  .products :deep(.el-form-item__content) {
    margin-left: 0 !important;
  }

  /* 按钮表单项特殊处理 */
  .products :deep(.button-form-item) {
    margin-bottom: 0;
  }

  .products :deep(.button-form-item .el-form-item__label) {
    display: none;
  }

  .products :deep(.button-form-item .el-form-item__content) {
    margin-left: 0 !important;
    width: 100% !important;
  }

  .button-group {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
    margin-left: 0;
    padding-left: 0;
    width: 100%;
  }

  /* 移除 Element UI 默认的按钮间距 */
  .products :deep(.button-group .el-button + .el-button) {
    margin-left: 0;
  }

  .query-btn,
  .reset-btn {
    width: 100%;
    min-width: auto;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .info-item {
    padding: 16px;
  }

  .info-icon {
    width: 40px;
    height: 40px;
  }

  .info-icon i {
    font-size: 18px;
  }

  .info-label {
    font-size: 0.8rem;
  }

  .info-value {
    font-size: 0.9rem;
  }

  .balance-highlight {
    font-size: 1rem;
  }

  .ellipsis {
    max-width: 150px;
  }

  .result-content {
    padding: 24px !important;
  }

  .card-header {
    padding: 20px 24px;
  }

  .no-result {
    padding: 40px 20px;
  }
}
</style>
